/* ============================================================
   RAZAB — Product page behaviour
   Shopify-ready adaptation of the Lovable implementation.
   Isolated to [data-razab-product].
   Integrates with the existing Razab cart through window.RazabCart.
   ============================================================ */
(function () {
  "use strict";

  function initRazabProduct(root) {
    if (!root || root.getAttribute("data-rzp-initialized") === "true") return;
    root.setAttribute("data-rzp-initialized", "true");

    var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var $$ = function (sel, ctx) {
      return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
    };

    var money = function (cents) {
      var fmt =
        root.getAttribute("data-money-format") ||
        (document.querySelector("[data-rzp-main]") &&
          document.querySelector("[data-rzp-main]").getAttribute("data-money-format")) ||
        "${{amount}}";

      var amount = (Number(cents || 0) / 100).toFixed(2);
      var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents || 0) / 100).toString())
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          amount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        );
    };

    /* reveal ------------------------------------------------ */
    var revealNodes = $$(".rzp-reveal");
    if (!("IntersectionObserver" in window)) {
      revealNodes.forEach(function (node) { node.classList.add("is-in"); });
    } else {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.06 }
      );
      revealNodes.forEach(function (node) { revealObserver.observe(node); });
    }

    function revealNow(scope) {
      $$(".rzp-reveal", scope).forEach(function (node) { node.classList.add("is-in"); });
    }

    /* toast ------------------------------------------------- */
    var toastEl = $("[data-rzp-toast]");
    var toastTimer;
    function toast(message) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.classList.add("is-visible");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove("is-visible");
      }, 2400);
    }

    /* carousel ---------------------------------------------- */
    function Carousel(el) {
      var viewport = $(".js-rzp-viewport", el);
      var track = $(".js-rzp-track", el);
      if (!viewport || !track) return null;

      var slides = Array.prototype.slice.call(track.children);
      var index = 0;
      var perView = 1;
      var resizeHandler;

      function measure() {
        if (!slides.length) return;
        var viewportWidth = viewport.clientWidth;
        var slideWidth = slides[0].getBoundingClientRect().width;

        /*
          Include the gap between slides. Using the slide width alone
          over-counts how many fit, so the last slide ended up partly
          cut off and the next arrow disabled a step too early.
        */
        var gap = 0;
        if (slides.length > 1) {
          gap = Math.max(
            0,
            slides[1].offsetLeft - slides[0].offsetLeft - slideWidth
          );
        }

        var step = Math.max(slideWidth + gap, 1);
        perView = Math.max(1, Math.floor((viewportWidth + gap) / step));
      }

      function maxIndex() {
        return Math.max(0, slides.length - perView);
      }

      function apply() {
        measure();
        index = Math.min(index, maxIndex());
        /*
          Measure from the FIRST SLIDE, not from the track. The mobile CSS
          gives .rzp-reels__track a left/right padding of 8% so the
          neighbouring cards peek in. Measuring from the track included that
          padding in the offset, so every slide was pulled 8% too far left:
          the first card sat flush against the edge and the last one ran off
          screen. Relative to slide 0 the padding is preserved at every index.
        */
        var base = slides[0] ? slides[0].offsetLeft : 0;
        var offset = slides[index] ? slides[index].offsetLeft - base : 0;
        track.style.transition = "transform 0.55s cubic-bezier(0.22,1,0.36,1)";
        track.style.transform = "translate3d(" + -offset + "px,0,0)";
        el.dispatchEvent(
          new CustomEvent("rzp:change", {
            detail: { index: index, max: maxIndex() }
          })
        );
      }

      function go(nextIndex) {
        index = Math.max(0, Math.min(nextIndex, maxIndex()));
        apply();
      }

      var startX = 0;
      var dragging = false;
      var delta = 0;

      viewport.addEventListener("pointerdown", function (event) {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        delta = 0;
        track.style.transition = "none";
      });

      viewport.addEventListener("pointermove", function (event) {
        if (!dragging) return;
        delta = event.clientX - startX;
        var dragBase = slides[0] ? slides[0].offsetLeft : 0;
        var offset =
          (slides[index] ? slides[index].offsetLeft - dragBase : 0) - delta;
        track.style.transform = "translate3d(" + -offset + "px,0,0)";
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(delta) > 45) go(index + (delta < 0 ? 1 : -1));
        else apply();
      }

      viewport.addEventListener("pointerup", endDrag);
      viewport.addEventListener("pointercancel", endDrag);
      viewport.addEventListener("pointerleave", endDrag);

      resizeHandler = function () { apply(); };
      window.addEventListener("resize", resizeHandler, { passive: true });
      apply();

      return {
        go: go,
        next: function () { go(index + 1); },
        prev: function () { go(index - 1); },
        get index() { return index; },
        get max() { return maxIndex(); },
        slides: slides
      };
    }

    /* product gallery --------------------------------------- */
    var galleryEl = $("[data-rzp-gallery]");
    var gallery = galleryEl ? Carousel(galleryEl) : null;

    if (gallery) {
      var prevBtn = $(".rzp-gallery__nav--prev", galleryEl);
      var nextBtn = $(".rzp-gallery__nav--next", galleryEl);
      var counter = $("[data-rzp-counter]", galleryEl);
      var thumbs = $$("[data-rzp-thumb]", galleryEl);

      function syncGallery(index) {
        if (counter) counter.textContent = index + 1 + " / " + gallery.slides.length;
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index >= gallery.max;

        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.setAttribute("aria-current", String(thumbIndex === index));
        });

        gallery.slides.forEach(function (slide, slideIndex) {
          if (slideIndex !== index) {
            slide.querySelectorAll("video").forEach(function (video) {
              try { video.pause(); } catch (e) {}
            });
          }
        });
      }

      galleryEl.addEventListener("rzp:change", function (event) {
        syncGallery(event.detail.index);
      });

      if (prevBtn) prevBtn.addEventListener("click", function () { gallery.prev(); });
      if (nextBtn) nextBtn.addEventListener("click", function () { gallery.next(); });

      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.addEventListener("click", function () { gallery.go(thumbIndex); });
      });

      galleryEl.addEventListener("keydown", function (event) {
        if (event.key === "ArrowRight") gallery.next();
        if (event.key === "ArrowLeft") gallery.prev();
      });

      syncGallery(0);

      var lightbox = $("[data-rzp-lightbox]");
      var expand = $("[data-rzp-expand]", galleryEl);

      if (lightbox && expand) {
        var lightboxImage = $("img", lightbox);
        var lastFocus = null;

        function openLightbox() {
          var slide = gallery.slides[gallery.index];
          var image = slide && slide.querySelector("img");
          if (!image || !lightboxImage) return;

          lightboxImage.src =
            image.getAttribute("data-full") || image.currentSrc || image.src;
          lightboxImage.alt = image.alt || "";
          lastFocus = document.activeElement;
          lightbox.hidden = false;

          var closeButton = $(".rzp-lightbox__close", lightbox);
          if (closeButton) closeButton.focus();
        }

        function closeLightbox() {
          lightbox.hidden = true;
          if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
        }

        expand.addEventListener("click", openLightbox);
        lightbox.addEventListener("click", function (event) {
          if (
            event.target === lightbox ||
            event.target.closest(".rzp-lightbox__close")
          ) {
            closeLightbox();
          }
        });

        document.addEventListener("keydown", function (event) {
          if (event.key === "Escape" && !lightbox.hidden) closeLightbox();
        });
      }
    }

    /* reels ------------------------------------------------- */
    var reelsEl = $("[data-rzp-reels]");
    if (reelsEl) {
      var reels = Carousel(reelsEl);

      if (reels) {
        var reelPrev = $("[data-rzp-reel-prev]", reelsEl);
        var reelNext = $("[data-rzp-reel-next]", reelsEl);
        var reelCount = $("[data-rzp-reel-counter]", reelsEl);

        function syncReels(index) {
          if (reelPrev) reelPrev.disabled = index === 0;
          if (reelNext) reelNext.disabled = index >= reels.max;
          if (reelCount) reelCount.textContent = index + 1 + " / " + (reels.max + 1);
        }

        reelsEl.addEventListener("rzp:change", function (event) {
          syncReels(event.detail.index);
        });

        if (reelPrev) reelPrev.addEventListener("click", function () { reels.prev(); });
        if (reelNext) reelNext.addEventListener("click", function () { reels.next(); });

        syncReels(0);

        $$("[data-rzp-reel]", reelsEl).forEach(function (card) {
          card.addEventListener("click", function () {
            var templateId = card.getAttribute("data-rzp-reel-template");
            if (!templateId) return;

            var template = document.getElementById(templateId);
            var dialog = $("[data-rzp-reel-dialog]");
            if (!template || !dialog) return;

            var mediaHost = $("[data-rzp-reel-dialog-media]", dialog);
            if (!mediaHost) return;

            mediaHost.innerHTML = template.innerHTML;
            dialog.hidden = false;
            document.body.style.overflow = "hidden";

            var playable = mediaHost.querySelector("video");
            if (playable) {
              playable.play().catch(function () {});
            }
          });
        });

        var reelDialog = $("[data-rzp-reel-dialog]");
        if (reelDialog) {
          function closeReel() {
            var mediaHost = $("[data-rzp-reel-dialog-media]", reelDialog);
            if (mediaHost) {
              mediaHost.querySelectorAll("video").forEach(function (video) {
                try { video.pause(); } catch (e) {}
              });
              mediaHost.innerHTML = "";
            }
            reelDialog.hidden = true;
            document.body.style.overflow = "";
          }

          reelDialog.addEventListener("click", function (event) {
            if (
              event.target === reelDialog ||
              event.target.closest(".rzp-lightbox__close")
            ) {
              closeReel();
            }
          });

          document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && !reelDialog.hidden) closeReel();
          });
        }
      }
    }

    /* accordions -------------------------------------------- */
    $$("[data-rzp-acc-trigger]").forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute("aria-controls"));
      if (!panel) return;

      trigger.addEventListener("click", function () {
        var open = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", String(!open));
        panel.classList.toggle("is-open", !open);
      });
    });

    /* variant / purchase engine ----------------------------- */
    var variantsScript = $("[data-rzp-variants]");
    var variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent || "[]");
      } catch (error) {
        console.error("RAZAB product variants JSON could not be parsed.", error);
      }
    }

    var form = $(".rzp-form");
    var idInput = form ? $("[name='id']", form) : null;
    var qtyInputs = $$("[data-rzp-qty-input]");
    var priceEl = $("[data-rzp-price]");
    var compareEl = $("[data-rzp-compare]");
    var saveEl = $("[data-rzp-save]");
    var atcButtons = $$("[data-rzp-atc]");
    var stickyPrice = $("[data-rzp-sticky-price]");
    var meterFill = $("[data-rzp-meter-fill]");
    var meterText = $("[data-rzp-meter-text]");
    var meterPercent = $("[data-rzp-meter-percent]");
    var savingsFormat = root.getAttribute("data-rzp-save-format") || "amount";
    var showPriceInAtc = root.getAttribute("data-rzp-atc-show-price") === "true";
    var atcBehavior = root.getAttribute("data-rzp-atc-behavior") || "drawer";
    var buyNowBehavior = root.getAttribute("data-rzp-buy-behavior") || "drawer";
    var fbtOpenCart = root.getAttribute("data-rzp-fbt-open-cart") !== "false";
    var freeShipThreshold = parseInt(
      root.getAttribute("data-free-shipping-threshold") || "0",
      10
    );

    function renderPackPrices() {
      if (!current) return;

      $$("[data-rzp-pack]").forEach(function (pack) {
        var qty = Math.max(1, Number(pack.getAttribute("data-qty")) || 1);
        var discount = Math.max(0, Math.min(100, Number(pack.getAttribute("data-discount")) || 0));
        var unit = Math.round(Number(current.price || 0) * (1 - discount / 100));
        var total = unit * qty;
        var compare = Number(current.price || 0) * qty;

        var unitNode = pack.querySelector("[data-rzp-pack-unit]");
        var totalNode = pack.querySelector("[data-rzp-pack-total]");
        var compareNode = pack.querySelector("[data-rzp-pack-compare]");
        var saveNode = pack.querySelector("[data-rzp-pack-save]");

        if (unitNode) unitNode.textContent = money(unit) + " / set";
        if (totalNode) totalNode.textContent = money(total);

        if (compareNode) {
          compareNode.textContent = discount > 0 ? money(compare) : "";
          compareNode.hidden = discount <= 0;
        }

        if (saveNode) {
          saveNode.textContent = "Save " + Math.round(discount) + "%";
          saveNode.hidden = discount <= 0;
        }
      });
    }

    function renderArrivalDate() {
      var node = $("[data-rzp-arrival]");
      if (!node) return;

      var startDays = Math.max(0, Number(node.getAttribute("data-start-days")) || 0);
      var endDays = Math.max(startDays, Number(node.getAttribute("data-end-days")) || startDays);
      var prefix = node.getAttribute("data-prefix") || "Arrives";
      var now = new Date();
      var start = new Date(now);
      var end = new Date(now);

      start.setDate(start.getDate() + startDays);
      end.setDate(end.getDate() + endDays);

      try {
        var fmt = new Intl.DateTimeFormat(undefined, {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
        node.textContent = prefix + " " + fmt.format(start) + " – " + fmt.format(end);
      } catch (error) {
        /* Keep Liquid fallback text if Intl is unavailable. */
      }
    }

    var current = variants[0] || null;
    var quantity = 1;

    function findVariant() {
      var optionGroups = $$("[data-rzp-option]");
      if (!optionGroups.length) {
        if (idInput) {
          var selectedId = Number(idInput.value);
          var byId = variants.filter(function (variant) {
            return Number(variant.id) === selectedId;
          })[0];
          if (byId) return byId;
        }
        return variants[0] || null;
      }

      var chosen = optionGroups.reduce(function (acc, group) {
        var checked = group.querySelector("input:checked");
        if (checked) acc.push(checked.value);
        return acc;
      }, []);

      return (
        variants.filter(function (variant) {
          return chosen.every(function (value, index) {
            return variant.options[index] === value;
          });
        })[0] || null
      );
    }

    /*
      The free shipping meter. This used to sit inline inside renderVariant,
      which is only ever called from the option and quantity handlers, so on
      a fresh page load nothing ran it and the bar kept the 0% it is rendered
      with. Pulling it out lets it also be primed once on load, below.
    */
    function renderShippingMeter(total) {
      if (!meterFill || freeShipThreshold <= 0) return;

      var pct = Math.min(
        100,
        Math.round((total / freeShipThreshold) * 100)
      );
      meterFill.style.width = pct + "%";
      if (meterPercent) meterPercent.textContent = pct + "%";

      if (meterText) {
        meterText.textContent =
          total >= freeShipThreshold
            ? meterText.getAttribute("data-unlocked") ||
              "Free shipping unlocked"
            : (meterText.getAttribute("data-prefix") || "You're") +
              " " +
              money(freeShipThreshold - total) +
              " " +
              (meterText.getAttribute("data-suffix") ||
                "away from free shipping");
      }
    }

    function renderVariant() {
      if (!variants.length && !atcButtons.length) return;

      if (!current) {
        atcButtons.forEach(function (button) {
          button.disabled = true;
          var label = button.querySelector("[data-rzp-atc-label]") || button;
          label.textContent = "Unavailable";
        });
        return;
      }

      if (idInput) idInput.value = current.id;

      var total = Number(current.price || 0) * quantity;

      if (priceEl) priceEl.textContent = money(current.price);
      if (stickyPrice) stickyPrice.textContent = money(total);

      var onSale =
        Number(current.compare_at_price || 0) > Number(current.price || 0);

      if (compareEl) {
        compareEl.textContent = onSale ? money(current.compare_at_price) : "";
        compareEl.hidden = !onSale;
      }

      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          if (savingsFormat === "percent") {
            saveEl.textContent =
              "Save " +
              Math.round(
                (1 - Number(current.price) / Number(current.compare_at_price)) * 100
              ) +
              "%";
          } else {
            saveEl.textContent =
              "Save " +
              money(Number(current.compare_at_price) - Number(current.price));
          }
        }
      }

      var buyNowButton = $("[data-rzp-buy-now]");
      if (buyNowButton) {
        var buyNowLabel = buyNowButton.getAttribute("data-label") || "Buy it now";
        var buyNowSoldOut = buyNowButton.getAttribute("data-soldout-text") || "Sold out";
        buyNowButton.disabled = !current.available;
        buyNowButton.textContent = current.available ? buyNowLabel : buyNowSoldOut;
      }

      atcButtons.forEach(function (button) {
        button.disabled = !current.available;

        var compact = button.hasAttribute("data-rzp-atc-compact");
        var label = !current.available
          ? button.getAttribute("data-soldout-text") || "Sold out"
          : compact
          ? button.getAttribute("data-compact-text") || "Add to bag"
          : showPriceInAtc
          ? (button.getAttribute("data-label") || "Add to Cart") +
            " — " +
            money(total)
          : button.getAttribute("data-label") || "Add to Cart";

        var labelNode = button.querySelector("[data-rzp-atc-label]") || button;
        labelNode.textContent = label;
      });

      var gallerySource = root.getAttribute("data-rzp-gallery-source") || "product";
      if (
        gallerySource !== "custom" &&
        current.featured_media_index !== null &&
        current.featured_media_index !== undefined &&
        gallery
      ) {
        gallery.go(Number(current.featured_media_index));
      }

      renderShippingMeter(total);

      renderPackPrices();
    }

    $$("[data-rzp-option] input").forEach(function (input) {
      input.addEventListener("change", function () {
        current = findVariant();
        renderVariant();

        if (current) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", current.id);
          window.history.replaceState({}, "", url.toString());
        }
      });
    });

    function setQty(next) {
      quantity = Math.max(1, Number(next) || 1);

      qtyInputs.forEach(function (input) {
        input.value = quantity;
      });

      $$("[data-rzp-pack]").forEach(function (pack) {
        pack.setAttribute(
          "aria-pressed",
          String(Number(pack.getAttribute("data-qty")) === quantity)
        );
      });

      renderVariant();
    }

    $$("[data-rzp-qty-minus]").forEach(function (button) {
      button.addEventListener("click", function () {
        setQty(quantity - 1);
      });
    });

    $$("[data-rzp-qty-plus]").forEach(function (button) {
      button.addEventListener("click", function () {
        setQty(quantity + 1);
      });
    });

    qtyInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        setQty(input.value);
      });
    });

    $$("[data-rzp-pack]").forEach(function (pack) {
      pack.addEventListener("click", function () {
        setQty(pack.getAttribute("data-qty"));
      });
    });

    /*
      Prime the meter for the variant that is already selected. Only the meter
      is run here, not the whole of renderVariant, so the price, the savings
      badge and everything else keep the values Liquid rendered them with.
    */
    if (current) {
      renderShippingMeter(Number(current.price || 0) * quantity);
    }

    /* exact integration with the working Razab cart drawer */
    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    }

    function cartAddUrl() {
      return cartRoot() + "cart/add.js";
    }

    function cartPageUrl() {
      return cartRoot() + "cart";
    }

    function checkoutUrl() {
      return cartRoot() + "checkout";
    }

    function openWorkingCart() {
      if (window.RazabCart && typeof window.RazabCart.open === "function") {
        window.RazabCart.open();
        return;
      }

      var drawer = document.getElementById("CartDrawer");
      var backdrop = document.querySelector('[data-overlay-for="CartDrawer"]');

      if (drawer) {
        drawer.setAttribute("data-open", "true");
        drawer.setAttribute("aria-hidden", "false");
        drawer.classList.add("open", "active", "is-open");
      }

      if (backdrop) {
        backdrop.setAttribute("data-open", "true");
        backdrop.setAttribute("aria-hidden", "false");
        backdrop.classList.add("open", "active", "is-open");
      }

      if (drawer || backdrop) {
        document.documentElement.classList.add("rz-cart-drawer-open");
      }
    }

    function refreshWorkingCart() {
      if (window.RazabCart && typeof window.RazabCart.refresh === "function") {
        return Promise.resolve(window.RazabCart.refresh());
      }

      return Promise.resolve();
    }

    /*
      Single cart-add path for:
      - Add to Cart
      - Buy it now
      - Frequently Bought Together

      It prefers the new working window.RazabCart API from cart-drawer.js.
    */
    function addPayload(payload, behavior) {
      behavior = behavior || "drawer";

      if (
        behavior === "drawer" &&
        window.RazabCart &&
        typeof window.RazabCart.add === "function"
      ) {
        return Promise.resolve(window.RazabCart.add(payload));
      }

      return fetch(cartAddUrl(), {
        method: "POST",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) throw result.data;

          if (behavior === "drawer") {
            return refreshWorkingCart().then(function () {
              openWorkingCart();
              return result.data;
            });
          }

          if (behavior === "cart") {
            window.location.assign(cartPageUrl());
            return result.data;
          }

          if (behavior === "checkout") {
            window.location.assign(checkoutUrl());
            return result.data;
          }

          /* stay on product page */
          return refreshWorkingCart().then(function () {
            return result.data;
          });
        });
    }

    function addCurrentProduct(button, behavior) {
      if (!current || !current.available) return Promise.resolve();

      var quantityToAdd = Math.max(
        1,
        Number(quantity) || 1
      );

      if (button) {
        button.classList.add("is-loading");
        button.setAttribute("aria-busy", "true");
      }

      return addPayload(
        {
          items: [
            {
              id: Number(current.id),
              quantity: quantityToAdd
            }
          ]
        },
        behavior
      )
        .then(function (result) {
          if (!button) return result;

          button.classList.remove("is-loading");
          button.removeAttribute("aria-busy");

          var labelNode =
            button.querySelector("[data-rzp-atc-label]") || button;
          var previous = labelNode.textContent;

          button.classList.add("is-added");
          labelNode.textContent = "✓ Added to cart";

          window.setTimeout(function () {
            button.classList.remove("is-added");
            labelNode.textContent = previous;
            renderVariant();
          }, 1800);

          return result;
        })
        .catch(function (error) {
          console.error("RAZAB add-to-cart failed.", error);
          if (button) {
            button.classList.remove("is-loading");
            button.removeAttribute("aria-busy");
          }

          toast(
            (error && (error.description || error.message)) ||
            "Could not add this item. Please try again."
          );

          throw error;
        });
    }

    /* Add to Cart ------------------------------------------ */
    atcButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        /*
          Ignore repeat clicks while a request is in flight. Without this a
          double tap sent two /cart/add calls and the item landed twice.
        */
        if (button.classList.contains("is-loading")) return;

        addCurrentProduct(button, atcBehavior).catch(function () {});
      });
    });

    /* Buy it now — connected to cart ----------------------- */
    var buyNowButton = $("[data-rzp-buy-now]");

    if (buyNowButton) {
      buyNowButton.addEventListener("click", function () {
        if (!current || !current.available || buyNowButton.disabled) return;

        var normalLabel =
          buyNowButton.getAttribute("data-label") || "Buy it now";
        var soldOutLabel =
          buyNowButton.getAttribute("data-soldout-text") || "Sold out";

        buyNowButton.disabled = true;
        buyNowButton.textContent =
          buyNowBehavior === "checkout"
            ? "Opening checkout…"
            : buyNowBehavior === "cart"
            ? "Opening cart…"
            : "Adding…";

        addCurrentProduct(null, buyNowBehavior)
          .then(function () {
            /*
              For drawer behavior, remain on the product page with the cart open.
              For cart/checkout behavior navigation happens in addPayload.
            */
            if (buyNowBehavior === "drawer" || buyNowBehavior === "stay") {
              buyNowButton.disabled = !(current && current.available);
              buyNowButton.textContent = current && current.available
                ? normalLabel
                : soldOutLabel;
            }
          })
          .catch(function () {
            buyNowButton.disabled = !(current && current.available);
            buyNowButton.textContent =
              current && current.available ? normalLabel : soldOutLabel;
          });
      });
    }

    /* Frequently Bought Together --------------------------- */
    $$("[data-rzp-fbt-add]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (button.disabled) return;

        var variantId = Number(button.getAttribute("data-variant-id"));
        if (!variantId) return;

        var original = button.textContent;
        var addedLabel = button.getAttribute("data-added-label") || "✓";

        button.disabled = true;
        button.textContent = "…";

        addPayload(
          { items: [{ id: variantId, quantity: 1 }] },
          fbtOpenCart ? "drawer" : "stay"
        )
          .then(function () {
            button.textContent = addedLabel;
            toast("Added to cart");

            window.setTimeout(function () {
              button.textContent = original;
              button.disabled = false;
            }, 1200);
          })
          .catch(function (error) {
            console.error("RAZAB frequently-bought add failed.", error);
            button.textContent = original;
            button.disabled = false;

            toast(
              (error && (error.description || error.message)) ||
              "Could not add that item. Please try again."
            );
          });
      });
    });

    /* sticky purchase bar ---------------------------------- */
    var sticky = $("[data-rzp-sticky]");
    var hero = $("[data-rzp-hero]");

    if (sticky) {
      function onScroll() {
        var threshold = hero
          ? hero.offsetTop + Math.min(hero.offsetHeight * 0.55, 700)
          : 420;
        sticky.classList.toggle("is-visible", window.scrollY > threshold);
      }

      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    /* fit studio ------------------------------------------- */
    var fit = $("[data-rzp-fit]");

    if (fit) {
      $$("[data-rzp-fit-tab]", fit).forEach(function (tab) {
        tab.addEventListener("click", function () {
          var target = tab.getAttribute("data-rzp-fit-tab");

          $$("[data-rzp-fit-tab]", fit).forEach(function (candidate) {
            candidate.setAttribute("aria-pressed", String(candidate === tab));
          });

          $$("[data-rzp-fit-panel]", fit).forEach(function (panel) {
            var match =
              panel.getAttribute("data-rzp-fit-panel") === target;
            panel.classList.toggle("rzp-hidden", !match);
            if (match) revealNow(panel);
          });

          var heading = $("[data-rzp-fit-heading]", fit);
          if (heading) {
            heading.textContent =
              tab.getAttribute("data-heading") || heading.textContent;
          }
        });
      });

      $$("[data-rzp-fit-item]", fit).forEach(function (button) {
        button.addEventListener("click", function () {
          $$("[data-rzp-fit-item]", fit).forEach(function (candidate) {
            candidate.setAttribute(
              "aria-pressed",
              String(candidate === button)
            );
          });

          var image = $("[data-rzp-fit-image]", fit);
          var title = $("[data-rzp-fit-title]", fit);
          var body = $("[data-rzp-fit-body]", fit);
          var capacity = $("[data-rzp-fit-capacity]", fit);

          var desktopImage = button.getAttribute("data-image");
          var mobileImage = button.getAttribute("data-mobile-image");
          var nextImage =
            window.matchMedia("(max-width:639px)").matches &&
            mobileImage
              ? mobileImage
              : desktopImage;

          if (image && nextImage) {
            /*
              The image lives inside a <picture> with a
              <source media="(max-width:639px)"> for the mobile crop. A
              matching <source> always beats img.src, so on phones the
              first item's image stayed on screen no matter which option
              was tapped. Update the source's srcset as well so the swap
              works at every breakpoint.
            */
            var picture = image.parentNode;
            var source =
              picture && picture.tagName === "PICTURE"
                ? picture.querySelector("source[media]")
                : null;

            image.style.opacity = "0";
            var preload = new Image();

            preload.onload = function () {
              if (source) {
                source.srcset = mobileImage || desktopImage || preload.src;
              }
              image.src = preload.src;
              image.alt = button.getAttribute("data-label") || "";
              image.style.opacity = "1";
            };

            preload.onerror = function () {
              /* Never leave the figure stuck at zero opacity. */
              image.style.opacity = "1";
            };

            preload.src = nextImage;
          }

          if (title) title.textContent = button.getAttribute("data-label") || "";
          /*
            innerHTML, not textContent: the Description setting is richtext, so
            data-body carries escaped markup. textContent would print the tags
            on screen. The value comes from theme settings or a product
            metafield, both merchant-controlled, never from shopper input.
          */
          if (body) body.innerHTML = button.getAttribute("data-body") || "";
          if (capacity) {
            capacity.textContent =
              button.getAttribute("data-capacity") || "";
          }
        });
      });

      var svg = $("[data-rzp-zone-svg]", fit);

      if (svg) {
        var specW = parseFloat(fit.getAttribute("data-width-cm")) || 0;
        var specD = parseFloat(fit.getAttribute("data-depth-cm")) || 0;
        var specH = parseFloat(fit.getAttribute("data-height-cm")) || 0;

        function drawZone(zone) {
          if (!specW || !specD || !specH) return;

          var rotated = false;
          var perRow = Math.floor(zone.w / specW);
          var rows = Math.floor(zone.d / specD);
          var rotatedPerRow = Math.floor(zone.w / specD);
          var rotatedRows = Math.floor(zone.d / specW);

          if (rotatedPerRow * rotatedRows > perRow * rows) {
            rotated = true;
            perRow = rotatedPerRow;
            rows = rotatedRows;
          }

          var layers = Math.floor(zone.h / specH);
          var width = rotated ? specD : specW;
          var depth = rotated ? specW : specD;
          var scale = 620 / Math.max(zone.w, 1);
          var svgHeight = Math.max(80, zone.d * scale);
          var total = perRow * rows * Math.max(layers, 0);

          var parts = [
            '<rect x="1" y="1" width="618" height="' +
              (svgHeight - 2) +
              '" rx="12" fill="none" stroke="currentColor" stroke-opacity="0.25" stroke-width="2"/>'
          ];

          for (var row = 0; row < rows; row++) {
            for (var col = 0; col < perRow; col++) {
              parts.push(
                '<rect x="' +
                  (col * width * scale + 6) +
                  '" y="' +
                  (row * depth * scale + 6) +
                  '" width="' +
                  Math.max(4, width * scale - 10) +
                  '" height="' +
                  Math.max(4, depth * scale - 10) +
                  '" rx="7" fill="currentColor" fill-opacity="0.18" stroke="currentColor" stroke-opacity="0.7" stroke-width="2">' +
                  '<animate attributeName="opacity" from="0" to="1" dur="0.35s" begin="' +
                  ((row * perRow + col) * 0.04) +
                  's" fill="freeze"/></rect>'
              );
            }
          }

          svg.setAttribute("viewBox", "0 0 620 " + svgHeight);
          svg.innerHTML = parts.join("");
          svg.setAttribute(
            "aria-label",
            total + " containers fit in the " + zone.label
          );

          function set(selector, value) {
            var node = $(selector, fit);
            if (node) node.textContent = value;
          }

          set("[data-rzp-zone-total]", total || "—");
          set(
            "[data-rzp-zone-total-note]",
            total
              ? "pieces fit in one " + zone.label.toLowerCase()
              : "this size is taller than the " + zone.label.toLowerCase()
          );
          set(
            "[data-rzp-zone-perlayer]",
            perRow + " across × " + rows + " deep"
          );
          set("[data-rzp-zone-layers]", String(Math.max(layers, 0)));
          set(
            "[data-rzp-zone-clearance]",
            Math.max(
              0,
              Math.round((zone.h - layers * specH) * 10) / 10
            ) + " cm"
          );
          set(
            "[data-rzp-zone-footprint]",
            specW + " × " + specD + " × " + specH + " cm"
          );
          set(
            "[data-rzp-zone-caption]",
            zone.label +
              " — " +
              zone.w +
              " × " +
              zone.d +
              " cm, " +
              zone.h +
              " cm of height. " +
              (rotated
                ? "Turned a quarter-turn for the tightest packing."
                : "Placed lengthwise.")
          );
        }

        var zoneButtons = $$("[data-rzp-zone]", fit);

        function zoneFrom(button) {
          return {
            label: button.getAttribute("data-label") || "zone",
            w: parseFloat(button.getAttribute("data-w")) || 60,
            d: parseFloat(button.getAttribute("data-d")) || 40,
            h: parseFloat(button.getAttribute("data-h")) || 30
          };
        }

        zoneButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            zoneButtons.forEach(function (candidate) {
              candidate.setAttribute(
                "aria-pressed",
                String(candidate === button)
              );
            });
            drawZone(zoneFrom(button));
          });
        });

        if (zoneButtons[0]) {
          zoneButtons[0].setAttribute("aria-pressed", "true");
          drawZone(zoneFrom(zoneButtons[0]));
        }
      }
    }

    /* anatomy ---------------------------------------------- */
    var anatomy = $("[data-rzp-anatomy]");

    if (anatomy) {
      var stage = $(".rzp-anatomy__stage", anatomy);
      var line = $("[data-rzp-hotspot-line]", anatomy);

      function activate(id) {
        $$("[data-rzp-hotspot]", anatomy).forEach(function (hotspot) {
          hotspot.setAttribute(
            "aria-pressed",
            String(hotspot.getAttribute("data-hotspot-id") === id)
          );
        });

        $$("[data-rzp-hotspot-card]", anatomy).forEach(function (card) {
          card.setAttribute(
            "aria-pressed",
            String(card.getAttribute("data-hotspot-id") === id)
          );
        });

        var dot = $(
          '[data-rzp-hotspot][data-hotspot-id="' + id + '"]',
          anatomy
        );
        var card = $(
          '[data-rzp-hotspot-card][data-hotspot-id="' + id + '"]',
          anatomy
        );

        if (
          line &&
          dot &&
          card &&
          stage &&
          window.matchMedia("(min-width:1024px)").matches
        ) {
          var stageBox = stage.getBoundingClientRect();
          var dotBox = dot.getBoundingClientRect();
          var cardBox = card.getBoundingClientRect();

          var x1 = dotBox.left + dotBox.width / 2 - stageBox.left;
          var y1 = dotBox.top + dotBox.height / 2 - stageBox.top;
          var x2 = stageBox.width;
          var y2 = cardBox.top + cardBox.height / 2 - stageBox.top;
          var length = Math.hypot(x2 - x1, y2 - y1);
          var angle =
            (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI;

          line.style.left = x1 + "px";
          line.style.top = y1 + "px";
          line.style.width = length + "px";
          line.style.transform = "rotate(" + angle + "deg)";
          line.hidden = false;
        } else if (line) {
          line.hidden = true;
        }
      }

      $$(
        "[data-rzp-hotspot], [data-rzp-hotspot-card]",
        anatomy
      ).forEach(function (element) {
        element.addEventListener("click", function () {
          activate(element.getAttribute("data-hotspot-id"));
        });
        element.addEventListener("mouseenter", function () {
          activate(element.getAttribute("data-hotspot-id"));
        });
      });

      var first = $("[data-rzp-hotspot]", anatomy);
      if (first) activate(first.getAttribute("data-hotspot-id"));

      window.addEventListener(
        "resize",
        function () {
          var active = $(
            '[data-rzp-hotspot][aria-pressed="true"]',
            anatomy
          );
          if (active) activate(active.getAttribute("data-hotspot-id"));
        },
        { passive: true }
      );
    }

    /* lifecycle ledger -------------------------------------- */
    var ledger = $("[data-rzp-ledger]");
    if (ledger) {
      var ledgerRange = ledger.querySelector("[data-rzp-ledger-range]");
      var mealsNode = ledger.querySelector("[data-rzp-ledger-meals]");
      var avoidedNode = ledger.querySelector("[data-rzp-ledger-avoided]");
      var plasticNode = ledger.querySelector("[data-rzp-ledger-plastic]");
      var costNode = ledger.querySelector("[data-rzp-ledger-cost]");
      var valueNode = ledger.querySelector("[data-rzp-ledger-value]");

      var productPriceCents = Math.max(0, Number(ledger.getAttribute("data-product-price")) || 0);
      var avoidedPerMeal = Math.max(0, Number(ledger.getAttribute("data-avoided-per-meal")) || 2);
      var plasticWeightG = Math.max(0, Number(ledger.getAttribute("data-plastic-weight-g")) || 22);
      var disposableCost = Math.max(0, Number(ledger.getAttribute("data-disposable-cost")) || 0.35);
      var ledgerYears = Math.max(1, Number(ledger.getAttribute("data-years")) || 5);

      function renderLedger() {
        var meals = Math.max(1, Number(ledgerRange ? ledgerRange.value : ledger.getAttribute("data-default-meals")) || 5);
        var avoided = Math.round(meals * 52 * avoidedPerMeal);
        var plasticKg = avoided * plasticWeightG / 1000;
        var uses = Math.max(1, meals * 52 * ledgerYears);
        var costPerUseCents = productPriceCents / uses;
        var valueReturned = Math.max(
          0,
          avoided * ledgerYears * disposableCost - productPriceCents / 100
        );

        if (mealsNode) mealsNode.textContent = Math.round(meals);
        if (avoidedNode) avoidedNode.textContent = avoided.toLocaleString();
        if (plasticNode) plasticNode.textContent = plasticKg.toFixed(plasticKg >= 10 ? 1 : 2);
        if (costNode) costNode.textContent = costPerUseCents.toFixed(1) + "¢";
        if (valueNode) valueNode.textContent = money(Math.round(valueReturned * 100));
      }

      if (ledgerRange) ledgerRange.addEventListener("input", renderLedger);
      renderLedger();
    }

    renderArrivalDate();

    /* boot purchase state only on the main section ---------- */
    if (variants.length) {
      current = findVariant() || variants[0] || null;
      setQty(1);
    }
  }

  function boot(scope) {
    var context = scope || document;

    if (
      context.nodeType === 1 &&
      context.matches &&
      context.matches("[data-razab-product]")
    ) {
      initRazabProduct(context);
    }

    var roots = context.querySelectorAll
      ? context.querySelectorAll("[data-razab-product]")
      : [];

    Array.prototype.forEach.call(roots, initRazabProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  /* Shopify Theme Customizer support */
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
